import Header from "../Header";
import Footer from "../Footer";
import Breadcrumbs from "../Breadcrumbs";import BannerImg from "../assets/Images/Banner.png";
import topImg from "../assets/Images/decoacademy.jpeg";

import BottomLogoImg from "../assets/Images/bottom-logo.png";
import LineImg from "../assets/Images/line.png";
import "./DecoAcademyPage.scss";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const DecoAcademyPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <Header />
      <div className="banner">
        <img src={BannerImg} alt="" />
        <div className="banner_title res">
          <h1 className="banner-main-title">{t("hk_renovation_guideline")}</h1>
          <p className="banner-subtitle">{t("deco_p1")}</p>
        </div>
      </div>
      <Breadcrumbs>
        <Link>{t("home")} &gt;</Link>
        <span> {t("deco_p1")}</span>
      </Breadcrumbs>
      <main className="deco-main-container">
        <header className="deco-header">
          <img src={topImg} alt="" className="deco-top-image"/>
          <h1 className="deco-main-title">{t("deco_p1")}</h1>
        </header>
        <section className="deco-video-section">
          <div className="video-container">
            <iframe
              className="deco-video"
              src={`https://www.youtube.com/embed/reCcV3Z627E`}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              title="Embedded youtube"
            />
          </div>
        </section>
        <section className="deco-content-section">
          <h2 className="deco-content-title">{t("deco_p1")}</h2>

          <div className="content-block">
            <h3 className="section-subtitle">{t("deco_p2")}</h3>
            <p className="content-text">{t("deco_p3")}</p>
            <p className="content-text">{t("deco_p4")}</p>
            <p className="content-text">{t("deco_p5")}</p>
          </div>

          <div className="content-block">
            <h3 className="section-subtitle">{t("deco_p6")}</h3>
            <p className="content-text">{t("deco_p7")}</p>
            <p className="content-text">{t("deco_p8")}</p>
            <p className="content-text">{t("deco_p9")}</p>
            <p className="content-text">{t("deco_p10")}</p>
          </div>

          <div className="content-block">
            <p className="content-text">{t("deco_p11")}</p>
            <p className="content-text">{t("deco_p12")}</p>
            <p className="content-text">2.{t("deco_p13")}</p>
            <p className="content-text">3.{t("deco_p14")}</p>
            <p className="content-text">4.{t("deco_p15")}</p>
          </div>

          <div className="content-block">
            <h3 className="section-subtitle">{t("deco_p16")}</h3>
            <p className="content-text">{t("deco_p17")}</p>
          </div>

          <div className="content-block">
            <h3 className="section-subtitle">{t("deco_p18")}</h3>
            <p className="content-text">{t("deco_p19")}</p>
          </div>

          <div className="content-block">
            <h3 className="section-subtitle">{t("deco_p20")}</h3>
            <p className="content-text">{t("deco_p21")}</p>
            <p className="content-text">{t("deco_p22")}</p>
            <p className="content-text">{t("deco_p23")}</p>
          </div>

          <div className="content-block">
            <h3 className="section-subtitle">{t("deco_p24")}</h3>
            <p className="content-text">{t("deco_p25")}</p>
            <h3 className="section-subtitle">{t("deco_p26")}</h3>
            <p className="content-text">{t("deco_p27")}</p>
          </div>

          <div className="content-block">
            <h3 className="section-subtitle">{t("deco_p28")}</h3>
            <h3 className="section-subtitle">{t("deco_p29")}</h3>
            <p className="content-text">{t("deco_p30")}</p>
            <p className="content-text">{t("deco_p31")}</p>
            <p className="content-text">{t("deco_p32")}</p>
          </div>

          <div className="content-block">
            <h3 className="section-subtitle">{t("deco_p33")}</h3>
            <p className="content-text">
              <a href="https://deco-academy.com/lessons/327" className="deco-link">
                https://deco-academy.com/lessons/327
              </a>
            </p>
          </div>
        </section>
        
        <section className="deco-line-section">
          <img src={LineImg} alt="" className="line-image" />
        </section>
      </main>
      
      <section className="temporary">
        <img src={BottomLogoImg} alt="" />
      </section>

      <Footer />
    </>
  );
};

export default DecoAcademyPage;
